import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import ComercioExteriorDomicilioForm from './ComercioExteriorDomicilioForm';

class ComercioExteriorReceptorForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { data = {} } = props;
    const { Receptor = {} } = data;

    this.state = {
      data: { ...Receptor },
      isValid: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  rules(data) {
    return {
      'NumRegIdTrib': ['string', 'min:1', 'max:40'],
    }
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    const validator = this.validate(data);
    const isValid = validator.passes() && this.state.isValidAddress;
    const newData = {
      ...this.props.data,
      Receptor: data
    }
    const event = {
      isValid: isValid,
      name: 'receptor'
    }

    this.props.onChange(newData, event);

    this.setState({
      data,
      isValid: isValid
    });
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnDomicilioDataChange = (event) => {
    const data = {
      ...this.state.data,
      Domicilio: event.data,
    }

    this.setState({
      isValidAddress: event.isValid,
    }, () => {
      this.handleOnChange(data);
    });
  }

  render() {
    const { data = {} } = this.state;

    const rules = this.rules(data);

    return (
      <div className="pb-4">
        <div>
          <strong className="text-black text-upper">Receptor</strong>
        </div>

        <div className="section pt-2">

          <Row>
            <Col sm md={ 4 }>
              <FormControl type="text"
                label="NumRegIdTrib"
                name="NumRegIdTrib"
                placeholder=""
                help=""
                minLength="1"
                maxLength="40"
                rules={ rules.NumRegIdTrib }
                value={ data.NumRegIdTrib }
                onChange={ this.handleOnChange }
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <strong>Domicilio</strong>
            </Col>
          </Row>

          <ComercioExteriorDomicilioForm
            required
            data={ data.Domicilio || {} }
            onFormDataChange={ this.handleOnDomicilioDataChange }
          />

        </div>
      </div>
    )
  }
}

export default ComercioExteriorReceptorForm;